import { useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import TextFieldGeneric from "../../components/Generics/TextFieldGeneric";
import { FloppyDisk } from "@phosphor-icons/react";
import Container from "../../components/Generics/Container";
import { useLocation, useNavigate } from "react-router-dom";

import { useSnack } from "../../redux/snack/snackHooks";
import { toast } from "react-toastify";
import { Feriado } from "../../model/entities/Feriado";
import feriadoApi from "../../api/feriadoApi";
import dayjs from "dayjs";
import DatePickerGeneric from "../../components/Generics/DatePickerGeneric";

const NovoFeriadoPage: React.FC = () => {
  const { state } = useLocation();
  const feriadoSelecionado = state as Feriado;

  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [data, setData] = useState(dayjs());
  const mostrarSnack = useSnack();
  const navigate = useNavigate();

  const salvar = async () => {
    try {
      if (feriadoSelecionado) {
        const resolveAfter3Sec = feriadoApi.update(feriadoSelecionado.id, {
          titulo: nome,
          descricao: descricao,
          data: data.toDate(),
        });

        toast.promise(resolveAfter3Sec, {
          pending: {
            render() {
              return "Atualizando dados do feriado";
            },
          },
          success: {
            render() {
              navigate("/feriado/listagem");
              return "Feriado atualizado";
            },
          },
          error: "Erro ao atualiza feriado",
        });
        return;
      }

      if (!nome) {
        mostrarSnack("Por favor informe o nome do feriado", "error");
        return;
      }

      if (!descricao) {
        mostrarSnack("Por favor informe a descrição do feriado", "error");
        return;
      }

      const resolveAfter3Sec = feriadoApi.insert({
        titulo: nome,
        descricao: descricao,
        data: data.toDate(),
      });

      toast.promise(resolveAfter3Sec, {
        pending: {
          render() {
            return "Cadastrando Feriado";
          },
        },
        success: {
          render() {
            navigate("/configuracoes/feriados");
            return "Feriado cadastrado";
          },
        },
        error: "Erro ao cadastrar feriado",
      });
    } catch (erro: any) {
      console.log("Erro ao cadastrar feriado", erro);
    }
  };

  useEffect(() => {
    if (feriadoSelecionado) {
      setNome(feriadoSelecionado.titulo);
      setDescricao(feriadoSelecionado.descricao);
      setData(dayjs(feriadoSelecionado.data));
    }
  }, [feriadoSelecionado]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container page>
        <Grid container xs={12} spacing={2}>
          <Grid item xs={12}>
            <TextFieldGeneric
              label="Nome do feriado"
              value={nome}
              maxLength={50}
              exibirMaxLength
              onChange={(value) => {
                setNome(value);
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <DatePickerGeneric
              label={"Data do feriado"}
              value={data}
              setValue={(value) => {
                if (value) setData(value);
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <TextFieldGeneric
              label="Descrição do feriado "
              value={descricao}
              placeholder="Ex: Celebração do Ano Novo, marcando o início do ano civil."
              minRows={10}
              type="text"
              onChange={(value) => {
                setDescricao(value);
              }}
            />
          </Grid>

          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Button
              style={{ margin: "5px" }}
              variant="contained"
              endIcon={<FloppyDisk size={32} />}
              onClick={() => salvar()}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default NovoFeriadoPage;
